<template>
  <div class="full-width">
    <input
      type="text"
      class="invisible-autofill-input"
      autocomplete="country"
      name="country"
      @change="onCountryAutofill"
    />
    <el-select
      v-model="selectedCountry"
      :disabled="loading"
      filterable
      placeholder="Select country or start typing"
    >
      <el-option
        v-for="country in countries"
        :key="country.key"
        :label="country.label"
        :value="country.key"
      >
        {{ country.label }}
      </el-option>
    </el-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'CountrySelect',
  props: {
    modelValue: String,
    countries: {
      type: Array,
      required: true
    },
    loading: Boolean
  },
  emits: ['update:modelValue'],
  setup(props, context) {
    const selectedCountry = ref(props.modelValue)

    watch(
      () => props.modelValue,
      (newVal) => {
        selectedCountry.value = newVal
      }
    )

    watch(selectedCountry, (val) => {
      context.emit('update:modelValue', val)
    })

    const onCountryAutofill = (event: Event) => {
      const target = event.target as HTMLInputElement | null
      if (!target?.value) return

      const key = target.value.trim().toLowerCase()
      const match = props.countries.find((c) => c.key.toLowerCase() === key)
      if (match) {
        selectedCountry.value = match.key
      }
    }

    return {
      selectedCountry,
      onCountryAutofill
    }
  }
})
</script>

<style lang="scss" scoped>
.invisible-autofill-input {
  position: absolute;
  opacity: 0;
  height: 0;
  pointer-events: none;
}
.el-select {
  :deep(.el-select__wrapper) {
    cursor: default;
  }
  :deep(.el-select__input):not(:focus) {
    cursor: pointer;
  }
}
</style>
